import { render, staticRenderFns } from "./BackerCenterPaymentsSkeleton.vue?vue&type=template&id=10a81ee2"
import script from "./BackerCenterPaymentsSkeleton.vue?vue&type=script&lang=js"
export * from "./BackerCenterPaymentsSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports